'use client';

import classes from "./public_provider_room.module.css";
import PublicProviderRoomsDesktop from "./public_provider_rooms_desktop";
import PublicProviderRoomsMobile from "./public_provider_rooms_mobile";

export default function PublicProviderRooms({provider, preview_value}) {

    if(!preview_value && (!provider.rooms || provider.rooms.length === 0)) return <></>

    return <div className={`${classes["public-provider-rooms-main"]}`}>
        <h3 className={preview_value ? `margin-0 color-gray-800 display-sm-semibold ${classes["public-provider-preview-main-title"]}` : "margin-0 color-gray-800 text-xl-medium"}>Terem információk</h3>
        <div className="show-on-pc-480 flex-column">
            <PublicProviderRoomsDesktop provider={provider} preview_value={preview_value} />
        </div>
        <div className="show-on-mobile-480 flex-column w-100">
            <PublicProviderRoomsMobile provider={provider} preview_value={preview_value} />
        </div>
    </div>
}
